module.exports = __webpack_public_path__ + "onboarding-project.cbf5457816be813a101c6e97fa7e36a9.hashedasset.svg";